import { Observable } from 'rxjs';
import { IListGateway } from '../gateways';
import { AppConfigService } from '../../app-config.service';
import { inject } from '@angular/core';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IServiceArea, SERVICE_AREAS } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';

export class ServiceAreaGateway implements IListGateway<
  never,
  IApiResponse<IServiceArea[]>
> {
  private readonly configService: AppConfigService = inject(AppConfigService);
  private readonly restCallBuilder: RestCallBuilder<IServiceArea[]> =
    new RestCallBuilder<IServiceArea[]>([]);

  list(): Observable<IApiResponse<IServiceArea[]>> {
    return this.restCallBuilder
      .getExternal(
        this.configService.get().general.tariffUrl + '/service-area/'
      )
      .validate(API_RESPONSE_SCHEMA(SERVICE_AREAS), 'ServiceArea.list')
      .handleMessages()
      .build();
  }
}
